<template>
    <div class="pl-4">
     <button @click="openModal" class="rounded-box">
      <div class="image-container" >
          <img src="@/assets/images/onboarding-girl.png" alt="Imagen" class="rounded-image" width="20px"/>
        </div>
        <div class="text-container">
        {{ $t('lang.button.tutorialOnboarding') }}
      </div>
      </button>

      <Modal
        name="modalVideo"
        :close="false"
          >
        <div class="col-12 embed-responsive embed-responsive-21by9 mt-4 mb-3">
         <iframe :src="getVideo" allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;" width="10%" height="100px" style="border: none; border-radius: 24px">
         </iframe>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="
            btn
            large
            cursor-pointer
            btn-lg btn-custom-color
            mx-1
            px-3
            py-2
          "
            @click="closeModal()"
          >
            <p>{{ $t('lang.button.close') }}</p>
          </button>
        </div>

      </Modal>




    </div>
</template>

<script>
import Modal from "@/components/Common/Modal.vue";
import { mapState, mapActions } from "vuex";


export default {
  data() {
    return {
    videoList:[
      { lang: "fr", url: "https://www.videoask.com/fpydkhwcl"},
      { lang: "en", url: "https://www.videoask.com/fmd8uhfra"},
      { lang: "es", url: "https://www.videoask.com/f7ay6wy4l"},
],
    };
  },
  name: 'RoundedBox',
  components: {Modal},
  computed: {
    ...mapState({
      user: state => state.authentication.user,
    }),
    getVideo(){
      //console.log(this.user.lang_code)
      return this.videoList.find( e => e.lang === this.user.lang_code).url
    }
  },
  methods: {

    openModal(){
      this.$modal.show("modalVideo");
    },
    closeModal() {
      this.$modal.hide("modalVideo");
    },

  },
};
</script>

<style scoped>
.rounded-box {
  border:1px solid gray;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  padding: 1px;
  background-color: rgb(31, 32, 63);
}

.image-container {
  width: 35px;
  height: 35px;
  overflow: hidden;
  border-radius: 50%;
}

.rounded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.text-container {
  color: white;
  text-align: center;
  padding: 2px;
  font-size: small;
  margin-right: 7px;
  margin-left: 7px;
}


.btn-custom-color {
  background: rgba(110, 110, 110, 0.19);
  margin-bottom: 5px;
}
</style>
